"use client";

import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { CreateObservationData, CreateObservationFormSchema } from "./schema";
import { useToast } from "@/hooks/use-toast";
import hooks from "@/hooks";
import { Form } from "@/components/ui/form";
import FormFields from "../Fields";
import Buttons from "@/components/core/Buttons";

interface ICreateObservationFormProps {
  chat_message_id: string;
  onSuccess?: () => void;
}

const CreateObservationForm = ({
  chat_message_id,
  onSuccess,
}: ICreateObservationFormProps) => {
  const { toast } = useToast();

  const form = useForm<CreateObservationData>({
    resolver: zodResolver(CreateObservationFormSchema),
    defaultValues: {
      observation: "",
      chat_message_id: chat_message_id,
    },
  });

  const createObservationService = hooks.useCreateObservation({
    onSuccess: () => {
      toast({
        title: "Observação criada com sucesso!",
        variant: "success",
      });
      if (onSuccess) {
        onSuccess();
      }
    },
    onError: (error: unknown) => {
      toast({
        title: "Não foi possível criar a observação",
        description: (error as Error).message,
        variant: "warning",
      });
    },
  });

  async function onSubmit(data: CreateObservationData) {
    await createObservationService.mutateAsync(data);
  }

  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(onSubmit)}
        className="w-full flex flex-col items-center gap-y-6"
      >
        <FormFields.TextareaFormField
          form={form}
          formName="observation"
          label="Observação"
          placeholder="Digite sua observação aqui..."
        />
        <Buttons.DefaultButton
          className="py-6"
          type="submit"
          title="Salvar Observação"
          isLoading={createObservationService.isPending}
        />
      </form>
    </Form>
  );
};

export default CreateObservationForm;
